import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SplashLabel from '@/shared/content/blocks/helpers/SplashLabel.vue';
import { ProductLabel } from '@/types/productServerApi';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSplashLabelNewArrival',
  props: {
    label: null
  },
  setup(__props: any) {




const { splashLabelNew } = useGlobalLabels(GlobalLabels.product);


return (_ctx: any,_cache: any) => {
  return (__props.label)
    ? (_openBlock(), _createBlock(SplashLabel, {
        key: 0,
        label: __props.label.text ? __props.label.text : _unref(splashLabelNew)
      }, null, 8, ["label"]))
    : _createCommentVNode("", true)
}
}

})